module.exports = __webpack_public_path__ + "static/15-a0f736c3d3e15394660c3470447f4849.jpeg";